<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2020-11-06 20:40:06
 * @LastEditors: voanit
 * @LastEditTime: 2020-11-25 09:53:39
-->
<template>
  <div class="data-inpt">
    <el-date-picker
      v-if="type == 'datetime'"
      v-model="data"
      :type="dataType"
      @change="changeDate"
      format="yyyy-MM-dd HH:mm"
      :picker-options="pickerOptions"
      value-format="timestamp"
      placeholder="选择日期时间"
    ></el-date-picker>

    <el-date-picker
      v-else
      v-model="data"
      :type="dataType"
      @change="changeDate"
      format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      value-format="timestamp"
      placeholder="选择日期时间"
    ></el-date-picker>
  </div>
</template>
<script>
import { filTime } from '@/filters'

export default {
  name: 'index',
  props: {
    value: {
      default: ''
    },
    disabled: {
      default: false
    },
    type: {
      default: 'date'
    },
    pastTime: {
      default: ''
    }
  },
  data() {
    const _this = this
    return {
      data: '',
      pastTimes: this.pastTime,
      dataType: this.type,
      pickerOptions: {
        disabledDate(time) {
          // 选择的日期
          if (_this.pastTimes != '') {
            return time.getTime() < _this.pastTimes
          }
        }
      }
    }
  },
  methods: {
    changeDate() {
      this.$emit('input', this.data)
      this.$emit('change', this.data)
    }
  },
  watch: {
    data(newVal, oldVal) {
      if (!newVal) {
        this.$emit('input', '')
      }
    },
    pastTime(newVal) {
      this.pastTimes = newVal
    },
    value(val) {
      this.data = val
    }
  },
  created() {
    this.pastTimes = this.pastTime
  }
}
</script>

<style scoped>
.data-inpt {
  width: 195px;
}
/*/deep/ .el-input{width:180px;}*/
</style>
